module.exports = __webpack_public_path__ + "static/img/4-001.6bc9abe.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/4-001.png
// module id = 235
// module chunks = 0